module.exports = __webpack_public_path__ + "media/images/icons/filled/folder-add-d05cb2496a791aeabbcc7a45dc95333d.svg";